import { useEffect } from 'react';
import { useContactStore } from '@/stores/contactStore.js';
import { addSampleContacts, hasSampleContacts } from '@/data/sampleContacts.js';

/**
 * Initialize sample contacts on first app load
 * Only runs once per user (checks if samples already exist)
 */
export function useInitializeContacts() {
    useEffect(() => {
        const contactStore = useContactStore.getState();
        const contacts = contactStore.getAllContacts();

        // Only add samples if user has no contacts and samples haven't been added before
        if (contacts.length === 0 && !hasSampleContacts()) {
            console.log('[Contacts] Initializing with sample contacts...');
            addSampleContacts();
        }
    }, []);
}
